<template>
  <div class="page">
    <div class="export-row">
      <h3>{{$t('智能硬件管理')}}</h3>
      <el-button type="primary" @click="handleBatchExport">{{$t('批量导出')}}</el-button>
    </div>

    <template v-for="item in comps">
      <el-card :key="item.comp">
        <template #header>
          <h4>{{ $t(item.title) }}</h4>
        </template>
        <component :is="item.name" :isPlain="true" @select="handleSelect" />
      </el-card>
    </template>
  </div>
</template>

<script>


import PowerWay from "@/components/hardware-manage/PowerWay";
import LiquidCrystal from "@/components/hardware-manage/LiquidCrystal";
import Sensor from "@/components/hardware-manage/Sensor";
import BluetoothVersion from "@/components/hardware-manage/BluetoothVersion";
import MasterChip from "@/components/hardware-manage/MasterChip";
import FitTemperature from "@/components/hardware-manage/FitTemperature";
import WeightSku from "@/components/hardware-manage/WeightSku";
import ProductBrand from "@/components/hardware-manage/ProductBrand";
import ProductModel from "@/components/hardware-manage/ProductModel";
import HardwareName from "@/components/hardware-manage/HardwareName";
import {request} from "@/config/request";
import {downloadFile} from "@/utils/common";

export default {
  name: "HardwareManageExport",
  components: {
    PowerWay,
    LiquidCrystal,
    Sensor,
    BluetoothVersion,
    MasterChip,
    FitTemperature,
    WeightSku,
    ProductBrand,
    ProductModel,
    HardwareName,
  },
  data() {
    return {
      comps: [
        {name: "HardwareName", title: "硬件名称"},
        {name: "ProductModel", title: "产品型号"},
        {name: "ProductBrand", title: "产品品牌"},
        {name: "WeightSku", title: "称重规格"},
        {name: "FitTemperature", title: "适用温度"},
        {name: "MasterChip", title: "主控芯片"},
        {name: "BluetoothVersion", title: "蓝牙版本"},
        {name: "Sensor", title: "传感器"},
        {name: "LiquidCrystal", title: "液晶"},
        {name: "PowerWay", title: "供电方式"},
      ],
      exportForm: {}
    }
  },
  methods: {
    // 批量导出
    async handleBatchExport() {
      try {
        /*const codes = Object.values(this.exportForm);
        if(!codes.flat().length) {
          this.$message.warning("请选择导出数据");
          return;
        }*/
        const res = await request(this.$api.common.iThardwareExport, this.exportForm, {isJson: true});
        downloadFile(res.excelUrl);
      } catch (e) {
        console.log(e);
      }
    },

    handleSelect(obj) {
      for (const key in obj) {
        this.exportForm[key] = obj[key];
      }
    }
  }
}
</script>

<style scoped>

.page {
  position: relative;
}

.el-card {
  margin-bottom: 18px;
}

.export-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  background: #FFFFFF;
  position: sticky;
  top: 0;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 12px;
  z-index: 2;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

</style>
